import { Injectable } from '@angular/core';
import { MatLegacyPaginatorIntl as MatPaginatorIntl } from '@angular/material/legacy-paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PaginatorI18n extends MatPaginatorIntl {

	public constructor(
		private m_translateService: TranslateService
	) {
		super();
		this.m_translateService.onLangChange.subscribe({
			next: (e: Event) => {
				this.getAndInitTranslations();
			}
		});
		this.getAndInitTranslations();
	}

	public getRangeLabel = (page: number, pageSize: number, length: number): string => {
		if (length === 0 || pageSize === 0) {
			return this.m_translateService.instant('GLOBAL.PAGINATOR.RANGE_PAGE_LABEL_1', { length });
		}
		length = Math.max(length, 0);
		const startIndex = page * pageSize;
		const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
		return this.m_translateService.instant('GLOBAL.PAGINATOR.RANGE_PAGE_LABEL_2', { startIndex: startIndex + 1, endIndex, length });
	}

	private getAndInitTranslations(): void {
		this.m_translateService.get('GLOBAL.PAGINATOR.ITEMS_PER_PAGE_LABEL').subscribe({
			next: (res: string) => {
				this.itemsPerPageLabel = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('GLOBAL.PAGINATOR.NEXT_PAGE_LABEL').subscribe({
			next: (res: string) => {
				this.nextPageLabel = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('GLOBAL.PAGINATOR.PREVIOUS_PAGE_LABEL').subscribe({
			next: (res: string) => {
				this.previousPageLabel = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('GLOBAL.PAGINATOR.FIRST_PAGE_LABEL').subscribe({
			next: (res: string) => {
				this.firstPageLabel = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('GLOBAL.PAGINATOR.LAST_PAGE_LABEL').subscribe({
			next: (res: string) => {
				this.lastPageLabel = res;
				this.changes.next(null);
			}
		});
	}
}
